export enum ORDER_TYPES {
  SERVICE_BOOKING_MEMBERSHIP = 'SERVICE_BOOKING_MEMBERSHIP',
  SERVICE_BOOKING_APPOINTMENT = 'SERVICE_BOOKING_APPOINTMENT',
  SERVICE_BOOKING_CLASS = 'SERVICE_BOOKING_CLASS',
  EVENTS = 'EVENTS',
  ORDER_AHEAD = 'ORDER_AHEAD',
  RESOURCE_BOOKING = 'RESOURCE_BOOKING',
}
